import React, { useEffect, useState }  from 'react';
import ENVIRONMENT from '../../../environments';
import Loader from './Loader'
import { getBaseURL } from '../../../environments/env';

const ProductARViewer = (props) => {
  const { id } = props.match.params;
  const USDZ_BASE_URL = ENVIRONMENT.USDZ_BASE_URL;
  const GLB_BASE_URL = ENVIRONMENT.ASSET_GLB_URL;
  
  // Get platform from query params which can either be aws or google
  const queryParams = new URLSearchParams(props.location.search);
  const platform = queryParams.get('platform');

  const [isLoading, setIsLoading] = useState(true);

  const getUSDZUrl = () => {
    setIsLoading(false);
    let link = USDZ_BASE_URL + id + '.usdz';
    if (platform === 'google') {
        link = link.replace(ENVIRONMENT.DEFAULT_BASE_URL, getBaseURL(platform));
    }
    return link;
  };

  const getGlbUrl = () => {
    let link = GLB_BASE_URL + id + '.glb';
    if (platform === 'google') {
        link = link.replace(ENVIRONMENT.DEFAULT_BASE_URL, getBaseURL(platform));
    }
    return link;
  };

  const isARSupported = async () => {
    if (navigator.userAgent.includes("Android")) {
        return navigator.xr?.isSessionSupported('immersive-ar').then((supported) => supported) ?? false;
    } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        // For iOS, generally assume AR is supported if it’s iOS 12+ for AR Quick Look support
        return parseInt(navigator.appVersion.match(/OS (\d+)_/)[1], 10) >= 12;
    }
    return false;
};

const getAndroidZUrl = () => {
    setIsLoading(false);
    if(isARSupported()) {
        return `intent://arvr.google.com/scene-viewer/1.0?file=${getGlbUrl()}&mode=ar_only#Intent;scheme=https;package=com.google.android.googlequicksearchbox;end;`;
    }
    else {
        return window.location.origin + '/android/' + id;
    }
}

  const openAr = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/iPhone|iPad|iPod/i.test(userAgent)) {
            window.location.href = getUSDZUrl();
        }
        else if (/android/i.test(userAgent)) {
            window.location.href = getAndroidZUrl();
        }
        else {
            window.location.href = getAndroidZUrl();
        }
    };

  useEffect(() => {
    openAr();
  }, []);

  return (
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#FFF'}}>
        <Loader isLoading={true} heading="Loading..." subHeading="Please wait while we load the AR Model." />
    </div>
  );
};

export default ProductARViewer; 